type FiltersProps = {
  tooltipFontSize: number;
  onTooltipFontChange: (value: number) => void;
  trackingFilter: string;
  onTrackingChange: (value: string) => void;
  articleFilter: string;
  onArticleChange: (value: string) => void;
  availableYears: string[];
  selectedYears: string[];
  onYearToggle: (year: string) => void;
  onReset: () => void;
  isOpen: boolean;
  onToggle: (open: boolean) => void;
};

export function BlulogFilters({
  tooltipFontSize,
  onTooltipFontChange,
  trackingFilter,
  onTrackingChange,
  articleFilter,
  onArticleChange,
  availableYears,
  selectedYears,
  onYearToggle,
  onReset,
  isOpen,
  onToggle,
}: FiltersProps) {
  return (
    <details
      className="blulog-filters"
      open={isOpen}
      onToggle={(event) => onToggle((event.currentTarget as HTMLDetailsElement).open)}
    >
      <summary className="blulog-filters-summary">
        <span className="blulog-filters-summary-text">Filtres</span>
      </summary>
      <aside className="blulog-sidebar">
        <section>
          <label htmlFor="tooltip-font" className="blulog-sidebar-label">
            Taille des infobulles ({tooltipFontSize}px)
          </label>
          <input
            id="tooltip-font"
            type="range"
            min={10}
            max={30}
            step={1}
            value={tooltipFontSize}
            onChange={(event) => onTooltipFontChange(Number(event.target.value))}
          />
        </section>

        <section>
          <label htmlFor="tracking-filter" className="blulog-sidebar-label">
            Numéro de suivi
          </label>
          <input
            id="tracking-filter"
            type="search"
            value={trackingFilter}
            onChange={(event) => onTrackingChange(event.target.value)}
            placeholder="Rechercher un tracking"
          />
        </section>

        <section>
          <label htmlFor="article-filter" className="blulog-sidebar-label">
            Article EI
          </label>
          <input
            id="article-filter"
            type="search"
            value={articleFilter}
            onChange={(event) => onArticleChange(event.target.value)}
            placeholder="Rechercher un article"
          />
        </section>

        <section>
          <p className="blulog-sidebar-label">Années</p>
          <div className="blulog-years">
            {availableYears.map((year) => (
              <label key={year} className="blulog-year-option">
                <input
                  type="checkbox"
                  checked={selectedYears.includes(year)}
                  onChange={() => onYearToggle(year)}
                />
                {year}
              </label>
            ))}
          </div>
        </section>

        <button type="button" className="blulog-reset" onClick={onReset}>
          Réinitialiser les filtres
        </button>
      </aside>
    </details>
  );
}
